// extracted by mini-css-extract-plugin
export default {"imageWrapper":"sI-z","twoColumnImage":"tI-z"};